"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyTypesEnum = void 0;
var SurveyTypesEnum = /*#__PURE__*/function (SurveyTypesEnum) {
  SurveyTypesEnum[SurveyTypesEnum["Intake"] = 2] = "Intake";
  SurveyTypesEnum[SurveyTypesEnum["Prescreening"] = 1] = "Prescreening";
  SurveyTypesEnum[SurveyTypesEnum["PhysicianAssessment"] = 3] = "PhysicianAssessment";
  SurveyTypesEnum[SurveyTypesEnum["TherapyAssessment"] = 4] = "TherapyAssessment";
  return SurveyTypesEnum;
}({});
exports.SurveyTypesEnum = SurveyTypesEnum;